import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconModule } from '../../../../icon/icon.module';

@Component({
    selector: 'lc-form-submit-button',
    standalone: true,
    imports: [CommonModule, IconModule],
    template: `
        <div class="submit-button-container">
            <button
                type="submit"
                [disabled]="disabled || loading"
                [ngClass]="getButtonClasses()"
                class="submit-button"
                (click)="onSubmit.emit()"
            >
                @if (loading) {
                    <svg
                        class="animate-spin h-5 w-5"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        ></circle>
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                    </svg>
                    <span>{{ loadingText || 'Enviando...' }}</span>
                } @else {
                    <span>{{ buttonText }}</span>
                    <icon-square-check />
                }
            </button>
        </div>
    `,
    styles: [
        `
            .submit-button-container {
                @apply flex justify-center pt-6 border-t border-gray-200 dark:border-gray-700;
            }

            .submit-button {
                @apply px-6 py-3 rounded-lg font-semibold transition-all duration-200 
                   flex items-center justify-center gap-2 text-white;
            }

            .submit-button:disabled {
                @apply opacity-50 cursor-not-allowed;
            }
        `,
    ],
})
export class FormSubmitButtonComponent {
    @Input() buttonText: string = 'Enviar';
    @Input() loadingText?: string;
    @Input() loading: boolean = false;
    @Input() disabled: boolean = false;
    @Input() color: 'primary' | 'success' | 'danger' | 'secondary' = 'primary';

    @Output() onSubmit = new EventEmitter<void>();

    getButtonClasses(): string {
        const baseClasses = 'submit-button';
        const colorClasses = {
            primary: 'bg-blue-600 hover:bg-blue-700 text-white',
            success: 'bg-green-600 hover:bg-green-700 text-white',
            danger: 'bg-red-600 hover:bg-red-700 text-white',
            secondary: 'bg-gray-600 hover:bg-gray-700 text-white',
        };

        return `${baseClasses} ${colorClasses[this.color]}`;
    }
}
